module.exports = new __parcel__URL__("magnifying_glass_error.86390a52.svg").toString();